export enum PaymentReason {
    Custom = 1,
    Appraisal = 2,
}
